import { render } from "./VLRouter.vue?vue&type=template&id=47e0e92d"
import script from "./VLRouter.vue?vue&type=script&lang=js"
export * from "./VLRouter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/sources/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__